import AcceptInvite from "./Views/Pages/Auth/AcceptInvite";
import ChangePassword from "./Views/Pages/Auth/ChangePassword";
import ForgotPassword from "./Views/Pages/Auth/ForgotPassword";
import Login from "./Views/Pages/Auth/Login";
import Signup from "./Views/Pages/Auth/Signup";
import ChooseProduct from "./Views/Pages/GetStarted/ChooseProduct";
import ChoosePlatform from "./Views/Pages/GetStarted/ChoosePlatform";
import CollectMagento from "./Views/Pages/GetStarted/CollectMagento";
import CollectAiAssistantMagento from "./Views/Pages/GetStarted/CollectAiAssistantMagento";
import AiAssistantMagentoSettings from "./Views/Pages/GetStarted/AiAssistantMagentoSettings";
import CollectAiAssistantWooCommerce from "./Views/Pages/GetStarted/CollectAiAssistantWooCommerce";
import AiAssistantWooCommerceSettings from "./Views/Pages/GetStarted/AiAssistantWooCommerceSettings";
import CollectCmsAssistant from "./Views/Pages/GetStarted/CollectCmsAssistant";
import CollectAiVisibility from "./Views/Pages/GetStarted/CollectAiVisibility";
import AiVisibilityComplete from "./Views/Pages/GetStarted/AiVisibilityComplete";
import CmsAssistantMessengerSettings from "./Views/Pages/GetStarted/CmsAssistantMessengerSettings";
import CmsAssistantComplete from "./Views/Pages/GetStarted/CmsAssistantComplete";
import CollectWooCommerce from "./Views/Pages/GetStarted/CollectWooCommerce";
import CollectDrupal from "./Views/Pages/GetStarted/CollectDrupal";
import CollectCustomSites from "./Views/Pages/GetStarted/CollectCustomSites";
import CustomPlatformSettings from "./Views/Pages/GetStarted/CustomPlatformSettings";
import NoResult from "./Views/Pages/Search/Reports/NoResult";
import ProductsClicked from "./Views/Pages/Search/Reports/ProductsClicked";
import ProductsShown from "./Views/Pages/Search/Reports/ProductsShown";
import SearchDashboard from "./Views/Pages/Search/Dashboard";
import SearchTerms from "./Views/Pages/Search/Reports/SearchTerms";
import Dashboard from "./Views/Pages/User/Dashboard";
import Settings from "./Views/Pages/User/Settings";
import Team from "./Views/Pages/User/Team";
import AddAccountChooseProduct from "./Views/Pages/User/Add_Account/ChooseProduct";
import AddAccountChoosePlatform from "./Views/Pages/User/Add_Account/ChoosePlatform";
import AddAccountCollectMagento from "./Views/Pages/User/Add_Account/CollectMagento";
import AddAccountCollectWooCommerce from "./Views/Pages/User/Add_Account/CollectWooCommerce";
import AddAccountCollectCustomSites from "./Views/Pages/User/Add_Account/CollectCustomSites";
import AddAccountCollectAiAssistantMagento from "./Views/Pages/User/Add_Account/CollectAiAssistantMagento";
import AddAccountAiAssistantMagentoSettings from "./Views/Pages/User/Add_Account/AiAssistantMagentoSettings";
import AddAccountCollectAiAssistantWooCommerce from "./Views/Pages/User/Add_Account/CollectAiAssistantWooCommerce";
import AddAccountAiAssistantWooCommerceSettings from "./Views/Pages/User/Add_Account/AiAssistantWooCommerceSettings";
import AddAccountCustomPlatformSettings from "./Views/Pages/User/Add_Account/CustomPlatformSettings";
import Merchandising from "./Views/Pages/Search/Merchandising/Index";
import Categories from "./Views/Pages/Search/Merchandising/Categories";
import Search from "./Views/Pages/Search/Merchandising/Search";
import LandingPage from "./Views/Pages/Search/Merchandising/LandingPage";
import Banners from "./Views/Pages/Search/Merchandising/Banners";
import PromoTiles from "./Views/Pages/Search/Merchandising/PromoTiles";
import EditCategory from "./Views/Pages/Search/Merchandising/EditCategory";
import EditSearch from "./Views/Pages/Search/Merchandising/EditSearch";
import AutoComplete from "./Views/Pages/Search/SearchOptions/AutoComplete";
import InstantSearch from "./Views/Pages/Search/SearchOptions/InstantSearch";
import EditLandingPage from "./Views/Pages/Search/Merchandising/EditLandingPage";
import Category from "./Views/Pages/Search/SearchOptions/Category";
import RevenueImpact from "./Views/Pages/Search/Reports/RevenueImpact";
import AutoCompleteDesign from "./Views/Pages/Search/Design/AutoComplete";
import InstantSearchDesign from "./Views/Pages/Search/Design/InstantSearch";
import DynamicBundling from "./Views/Pages/Upsell/Bundling/DynamicBundling";
// import ColorFamilies from "./Views/Pages/Filters/ColorFamilies";
// import FiltersList from "./Views/Pages/Filters/FiltersList";
import SynonymsList from "./Views/Pages/Synonyms/SynonymsList";
import DrupalComplete from "./Views/Pages/GetStarted/DrupalComplete";
// import AutocompleteSettings from "./Views/Pages/Drupal/AutocompleteSettings";
// import SearchResultSettings from "./Views/Pages/Drupal/SearchResultSettings";
// import DesignSettings from "./Views/Pages/Drupal/DesignSettings";
import DisplayFieldMapping from "./Views/Pages/Drupal/DisplayFieldMapping";
import CustomRanking from "./Views/Pages/Drupal/CustomRanking";
import SearchQueryFieldsSettings from "./Views/Pages/Drupal/SearchQueryFieldsSettings";
import DrupalSemanticSearchSettingsPage from "./Views/Pages/Drupal/SemanticSearchSettingsPage";
// AI Assistant Components
import AIAssistantDashboard from "./Views/Pages/AIAssistant/AIAssistantDashboard";
import AIAssistantConversations from "./Views/Pages/AIAssistant/AIAssistantConversations";
import AIAssistantProducts from "./Views/Pages/AIAssistant/AIAssistantProducts";
import AIAssistantCollectionPages from "./Views/Pages/AIAssistant/AIAssistantCollectionPages";
import AIAssistantQuestions from "./Views/Pages/AIAssistant/AIAssistantQuestions";
import AIAssistantResponses from "./Views/Pages/AIAssistant/AIAssistantResponses";
import AIAssistantTraining from "./Views/Pages/AIAssistant/AIAssistantTraining";
import AIAssistantTrainingList from "./Views/Pages/AIAssistant/AIAssistantTrainingList";
// import AIAssistantIntegration from "./Views/Pages/AIAssistant/AIAssistantIntegration";
import AIAssistantSettings from "./Views/Pages/AIAssistant/AIAssistantSettings";
import QuestionForm from "./Views/Pages/AIAssistant/QuestionForm";
import CustomProductPageCrawl from "./Views/Pages/AIAssistant/CustomProductPageCrawl";
import AIAssistantWebsiteMetadata from "./Views/Pages/AIAssistant/AIAssistantWebsiteMetadata";
import ColorFamilies from "./Views/Pages/Search/Filters/ColorFamilies";
import FiltersList from "./Views/Pages/Search/Filters/FiltersList";
import AddFilter from "./Views/Pages/Search/Filters/AddFilter";
import EditFilter from "./Views/Pages/Search/Filters/EditFilter"
import TopPerformingProducts from "./Views/Pages/Search/Reports/TopPerformingProducts";
import LowPerformingProducts from "./Views/Pages/Search/Reports/LowPerformingProducts";
import AlmostBuyProducts from "./Views/Pages/Search/Reports/AlmostBuyProducts";
// import SearchConversionFunnel from "./Views/Pages/Search/Reports/SearchConversionFunnel";
import ZeroResultQueries from "./Views/Pages/Search/Reports/ZeroResultQueries";
import AISynonymPreview from "./Views/Pages/Search/Reports/AISynonymPreview";
import LowProductPageViewQueries from "./Views/Pages/Search/Reports/LowProductPageViewQueries";
// import HighExitQueries from "./Views/Pages/Search/Reports/HighExitQueries";
import HighIntentLowConversionQueries from "./Views/Pages/Search/Reports/HighIntentLowConversionQueries";
// import Category from "./Views/Pages/Search/SearchOptions/Category";
import Rules from "./Views/Pages/Search/Merchandising/Rules.jsx"
import RuleEditor from "./Views/Pages/Search/Merchandising/RuleEditor.jsx";
// import HighPerformingCollections from "./Views/Pages/Search/Reports/HighPerformingCollection.jsx";
// import LowPerformingCollections from "./Views/Pages/Search/Reports/LowPerformingCollection.jsx";
// import PoorPerformingCollections from "./Views/Pages/Search/Reports/PoorPerformingCollection.jsx";
// CMS Assistant Components
import CmsAssistantDashboard from "./Views/Pages/CmsAssistant/Dashboard";
import EnterpriseSearchReportPage from "./Views/Pages/CmsAssistant/Reports/EnterpriseSearchReportPage";
import AiVisibilityDashboard from "./Views/Pages/AiVisibility/Dashboard";
import AiVisibilityReport from "./Views/Pages/AiVisibility/Report";
import AiVisibilityMonitoring from "./Views/Pages/AiVisibility/Monitoring";
import AiVisibilityWritingAssistance from "./Views/Pages/AiVisibility/WritingAssistance";
import AiVisibilityMonitoringWritingAssistance from "./Views/Pages/AiVisibility/MonitoringWritingAssistance";
import AiVisibilityContentStudioSettings from "./Views/Pages/AiVisibility/ContentStudioSettings";
import AiVisibilityWritingView from "./Views/Pages/AiVisibility/WritingView";
import AiVisibilityWritingDeployments from "./Views/Pages/AiVisibility/WritingDeployments";
import AiVisibilityWritingDeployView from "./Views/Pages/AiVisibility/WritingDeployView";
import AiVisibilityWritingRecommendations from "./Views/Pages/AiVisibility/WritingRecommendations";
import AiVisibilityDualLens from "./Views/Pages/AiVisibility/DualLens";
import AiVisibilityDualLensView from "./Views/Pages/AiVisibility/DualLensView";
import AiVisibilityLlmsTxt from "./Views/Pages/AiVisibility/LlmsTxt";
import AiVisibilityLlmsTxtView from "./Views/Pages/AiVisibility/LlmsTxtView";
import AiVisibilitySchemaOptimizer from "./Views/Pages/AiVisibility/SchemaOptimizer";
import AiVisibilitySchemaOptimizerRun from "./Views/Pages/AiVisibility/SchemaOptimizerRun";
import AiVisibilitySchemaOptimizerView from "./Views/Pages/AiVisibility/SchemaOptimizerView";
// import AiVisibilityRecommendations from "./Views/Pages/AiVisibility/Recommendations";
import AiVisibilityRecommendationViewPage from "./Views/Pages/AiVisibility/RecommendationView";
import CmsAssistantContentSearch from "./Views/Pages/CmsAssistant/ContentSearch";
// import CmsAssistantContentSync from "./Views/Pages/CmsAssistant/ContentSync";
import CmsAssistantConversations from "./Views/Pages/CmsAssistant/Conversations";
import MessengerSettings from "./Views/Pages/CmsAssistant/MessengerSettings";
import Integrations from "./Views/Pages/CmsAssistant/Integrations";
import NetSuiteCatalogSync from "./Views/Pages/CmsAssistant/NetSuiteCatalogSync";
import CmsAssistantTrainingDocuments from "./Views/Pages/CmsAssistant/CmsAssistantTrainingDocuments";
import CollectionProduct from "./Views/Pages/Search/Reports/CollectionProduct";
import KeywordProducts from "./Views/Pages/Search/Reports/KeywordProducts";
import ProductKeywords from "./Views/Pages/Search/Reports/ProductKeywords";

export const authRoutes = [
	{
		path: "/login",
		name: "Login",
		component: <Login />,
		layout: "/auth",
	},
	{
		path: "/signup",
		name: "Register",
		component: <Signup />,
		layout: "/auth",
	},
	{
		path: "/forgotPassword",
		name: "Forgot Password",
		component: <ForgotPassword />,
		layout: "/auth",
	},
	{
		path: "/change-password",
		name: "Change Password",
		component: <ChangePassword />,
		layout: "/auth",
	},
	{
		path: "/accept-invite",
		name: "Accept Invitation",
		component: <AcceptInvite />,
		layout: "/auth",
	},
];

export const getStartedRoutes = [
	{
		path: "/chooseProduct",
		name: "Choose Product",
		component: <ChooseProduct />,
		layout: "/getStarted",
	},
	{
		path: "/choosePlatform",
		name: "Choose Platform",
		component: <ChoosePlatform />,
		layout: "/getStarted",
	},
	{
		path: "/magento",
		name: "Magento",
		component: <CollectMagento />,
		layout: "/getStarted",
	},
	{
		path: "/woocommerce",
		name: "WooCommerce",
		component: <CollectWooCommerce />,
		layout: "/getStarted",
	},
	{
		path: "/drupal",
		name: "Drupal",
		component: <CollectDrupal />,
		layout: "/getStarted",
	},
	{
		path: "/custom",
		name: "Custom Sites",
		component: <CollectCustomSites />,
		layout: "/getStarted",
	},
	{
		path: "/aiAssistantMagento",
		name: "AI Assistant Magento",
		component: <CollectAiAssistantMagento />,
		layout: "/getStarted",
	},
	{
		path: "/aiAssistantMagentoSettings",
		name: "AI Assistant Magento Settings",
		component: <AiAssistantMagentoSettings />,
		layout: "/getStarted",
	},
	// {
	// 	path: "/aiAssistantWooCommerce",
	// 	name: "AI Assistant WooCommerce",
	// 	component: <CollectAiAssistantWooCommerce />,
	// 	layout: "/getStarted",
	// },
	// {
	// 	path: "/aiAssistantWooCommerceSettings",
	// 	name: "AI Assistant WooCommerce Settings",
	// 	component: <AiAssistantWooCommerceSettings />,
	// 	layout: "/getStarted",
	// },
	{
		path: "/aiAssistantWooCommerce",
		name: "AI Assistant WooCommerce",
		component: <CollectAiAssistantWooCommerce />,
		layout: "/getStarted",
	},
	{
		path: "/aiAssistantWooCommerceSettings",
		name: "AI Assistant WooCommerce Settings",
		component: <AiAssistantWooCommerceSettings />,
		layout: "/getStarted",
	},
	{
		path: "/customPlatformSettings",
		name: "Custom Platform Settings",
		component: <CustomPlatformSettings />,
		layout: "/getStarted",
	},
	{
		path: "/cmsAssistant",
		name: "CMS Assistant",
		component: <CollectCmsAssistant />,
		layout: "/getStarted",
	},
	{
		path: "/cmsAssistantSettings",
		name: "CMS Assistant Settings",
		component: <CmsAssistantMessengerSettings />,
		layout: "/getStarted",
	},
	{
		path: "/cmsAssistantComplete",
		name: "CMS Assistant Complete",
		component: <CmsAssistantComplete />,
		layout: "/getStarted",
	},
	{
		path: "/aiVisibility",
		name: "AI Visibility",
		component: <CollectAiVisibility />,
		layout: "/getStarted",
	},
	{
		path: "/aiVisibilityComplete",
		name: "AI Visibility Complete",
		component: <AiVisibilityComplete />,
		layout: "/getStarted",
	},
	{
		path: "/drupalApiKey",
		name: "Drupal API Key",
		component: <DrupalComplete />,
		layout: "/getStarted"
	}
];

export const userRoutes = [
	{
		path: "/dashboard",
		name: "Overview",
		component: <Dashboard />,
		menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-home stl-text-accent-600 stl-ml-[-3px] stl-shrink-0"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`,
		layout: "/user",
		type: "mainMenu"
	},
	{
		path: "/dashboard",
		name: "Search",
		component: <SearchDashboard />,
		//menuSvg: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" class="stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><circle cx="40" cy="32" r="28" fill="currentcolor"></circle><rect x="30" y="22" width="20" height="20" rx="10" fill="#fff"></rect><path d="M43 63.5 54.5 60l6 17h-12L43 63.5Z" fill="currentcolor"></path></svg>`,
		menuSvg: `<svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" class="stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M64.6 36V32C64.6 22.3 57.7 15.4 48 15.4H32C22.3 15.4 15.4 22.3 15.4 32C15.4 41.7 22.3 48.6 32 48.6H40" stroke="currentColor" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M61.9 58.8C63.2 57.5 64 55.7 64 54C64 50.7 61.3 48 58 48C54.7 48 52 50.7 52 54C52 57.3 54.7 60 58 60C59.8 60 61.6 59.2 62.9 57.9L67 62" stroke="currentColor" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
		layout: "/search",
		type: "mainMenu",
		productType: "search"
	},
	{
		path: "/dynamic",
		name: "Recommendation",
		component: <DynamicBundling />,
		menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>`,
		layout: "/upsell",
		type: "mainMenu",
		availablePlatforms: ["shopify", "bigcommerce"],
		productType: "search"
	},
	{
		path: "/dashboard",
		name: "AI Assistant",
		component: <AIAssistantDashboard />,
		menuSvg: `<i class="fas fa-microchip stl-text-grey-400 stl-shrink-0" style="font-size: 18px; margin-left: 1px; margin-top:5px"></i>`,
		layout: "/aiassistant",
		type: "mainMenu",
		productType: "aiassistant"
	},
	{
		path: "/websites",
		name: "Add Account",
		component: <AddAccountChooseProduct />,
		layout: "/user",
		menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>`,
		type: "bottomMenu",
	},
	{
		path: "/addAccount/choosePlatform",
		name: "Choose Platform",
		component: <AddAccountChoosePlatform />,
		layout: "/user",
	},
	{
		path: "/addAccount/magento",
		name: "Magento",
		component: <AddAccountCollectMagento />,
		layout: "/user",
	},
	{
		path: "/addAccount/woocommerce",
		name: "WooCommerce",
		component: <AddAccountCollectWooCommerce />,
		layout: "/user",
	},
	{
		path: "/addAccount/custom",
		name: "Custom Sites",
		component: <AddAccountCollectCustomSites />,
		layout: "/user",
	},
	{
		path: "/addAccount/aiAssistantMagento",
		name: "AI Assistant Magento",
		component: <AddAccountCollectAiAssistantMagento />,
		layout: "/user",
	},
	{
		path: "/addAccount/aiAssistantMagentoSettings",
		name: "AI Assistant Magento Settings",
		component: <AddAccountAiAssistantMagentoSettings />,
		layout: "/user",
	},
	// {
	// 	path: "/addAccount/aiAssistantWooCommerce",
	// 	name: "AI Assistant WooCommerce",
	// 	component: <AddAccountCollectAiAssistantWooCommerce />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/aiAssistantWooCommerceSettings",
	// 	name: "AI Assistant WooCommerce Settings",
	// 	component: <AddAccountAiAssistantWooCommerceSettings />,
	// 	layout: "/user",
	// },
	{
		path: "/addAccount/aiAssistantWooCommerce",
		name: "AI Assistant WooCommerce",
		component: <AddAccountCollectAiAssistantWooCommerce />,
		layout: "/user",
	},
	{
		path: "/addAccount/aiAssistantWooCommerceSettings",
		name: "AI Assistant WooCommerce Settings",
		component: <AddAccountAiAssistantWooCommerceSettings />,
		layout: "/user",
	},
	{
		path: "/addAccount/customPlatformSettings",
		name: "Custom Platform Settings",
		component: <AddAccountCustomPlatformSettings />,
		layout: "/user",
	},
	{
		path: "/addAccount/aiVisibility",
		name: "AI Visibility",
		component: <CollectAiVisibility completePath="/user/addAccount/aiVisibilityComplete" />,
		layout: "/user",
	},
	{
		path: "/addAccount/aiVisibilityComplete",
		name: "AI Visibility Complete",
		component: <AiVisibilityComplete collectPath="/user/addAccount/aiVisibility" />,
		layout: "/user",
	},
	{
		path: "/dashboard",
		name: "CMS Assistant",
		component: <CmsAssistantDashboard />,
		menuSvg: `<i class="fas fa-file-alt stl-text-grey-400 stl-shrink-0" style="font-size: 18px; margin-left: 1px; margin-top:5px"></i>`,
		layout: "/cmsassistant",
		type: "mainMenu",
		productType: "cmsassistant"
	},
	{
		path: "/audit-list",
		name: "AI Visibility",
		component: <AiVisibilityDashboard />,
		menuSvg: `<i class="fas fa-eye stl-text-grey-400 stl-shrink-0" style="font-size: 18px; margin-left: 1px; margin-top:5px"></i>`,
		layout: "/aivisibility",
		type: "mainMenu",
		productType: "aivisibility"
	},
	// {
	// 	path: "/websites",
	// 	name: "Add Account",
	// 	component: <AddAccountChooseProduct />,
	// 	layout: "/user",
	// 	menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>`,
	// 	type: "bottomMenu",
	// },
	// {
	// 	path: "/addAccount/choosePlatform",
	// 	name: "Choose Platform",
	// 	component: <AddAccountChoosePlatform />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/magento",
	// 	name: "Magento",
	// 	component: <AddAccountCollectMagento />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/woocommerce",
	// 	name: "WooCommerce",
	// 	component: <AddAccountCollectWooCommerce />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/custom",
	// 	name: "Custom Sites",
	// 	component: <AddAccountCollectCustomSites />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/aiAssistantMagento",
	// 	name: "AI Assistant Magento",
	// 	component: <AddAccountCollectAiAssistantMagento />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/aiAssistantMagentoSettings",
	// 	name: "AI Assistant Magento Settings",
	// 	component: <AddAccountAiAssistantMagentoSettings />,
	// 	layout: "/user",
	// },
	// {
	// 	path: "/addAccount/customPlatformSettings",
	// 	name: "Custom Platform Settings",
	// 	component: <AddAccountCustomPlatformSettings />,
	// 	layout: "/user",
	// },
	{
		path: "/settings",
		name: "Settings",
		component: <Settings />,
		layout: "/user",
		menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>`,
		type: "bottomMenu",
	},
	{
		path: "/team",
		name: "Team",
		component: <Team />,
		layout: "/user",
		menuSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users stl-text-grey-400 stl-ml-[-3px] stl-shrink-0"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>`,
		type: "bottomMenu",
	},
	{
		path: "/integrations",
		name: "Integrations",
		component: <Integrations />,
		layout: "/user",
		menuSvg: `<i class="fas fa-plug stl-text-grey-400 stl-shrink-0" style="font-size: 16px;"></i>`,
		type: "bottomMenu",
	},
	{
		path: "/integrations/netsuite-catalog-sync",
		name: "NetSuite catalog sync",
		component: <NetSuiteCatalogSync />,
		layout: "/user",
	},
]

export const UpsellRoutes = [
	{
		name: "Dynamic Bundling",
		fontIcon: "fa-cube",
		layout: "/upsell",
		type: "upsellMenu",
		subMenu: [
			{
				path: "/dynamic",
				name: "Bundling",
				layout: "/upsell",
				menuFlag: true,
				component: <DynamicBundling />,
			},
		],
	},
];

export const AIAssistantRoutes = [
	// {
	// 	name: "AI Shopping",
	// 	fontIcon: "fa-robot",
	// 	layout: "/aiassistant",
	// 	type: "aiMenu",
	// 	subMenu: [
			{
				path: "/dashboard",
				name: "Dashboard",
				layout: "/aiassistant",
				fontIcon: "fa-desktop",
				menuFlag: true,
				component: <AIAssistantDashboard />,
			},
			{
				
				name: "Conversations",
				layout: "/aiassistant",
				fontIcon: "fa-message",
				menuFlag: true,
				subMenu: [
					{
						name: "Shopping Conversation",
						path: "/conversations",
						component: <AIAssistantConversations />,
						menuFlag: true,
						layout: "/aiassistant"
					},
					{
						name: "PDP Responses",
						path: "/responses",
						layout: "/aiassistant",
						menuFlag: true,
						component: <AIAssistantResponses />,
					}
				],
			},
			{
				path: "/products",
				name: "Products",
				layout: "/aiassistant",
				fontIcon: "fa-cart-shopping",
				menuFlag: true,
				component: <AIAssistantProducts />,
			},
			{
				path: "/collection-pages",
				name: "Collection pages",
				layout: "/aiassistant",
				fontIcon: "fa-layer-group",
				menuFlag: true,
				component: <AIAssistantCollectionPages />,
			},
			{
				path: "/productPageCrawl",
				name: "Product page crawl",
				layout: "/aiassistant",
				menuFlag: true,
				fontIcon: "fa-spider",
				component: <CustomProductPageCrawl />,
				availablePlatforms: ["custom"]
			},
			{
				path: "/questions",
				name: "Questions",
				layout: "/aiassistant",
				fontIcon: "fa-circle-question",
				menuFlag: true,
				component: <AIAssistantQuestions />,
			},
			{
				path: "/questions/add",
				name: "Add Question",
				layout: "/aiassistant",
				menuFlag: false,
				component: <QuestionForm />,
			},
			{
				path: "/questions/edit",
				name: "Edit Question",
				layout: "/aiassistant",
				menuFlag: false,
				component: <QuestionForm />,
			},
			// {
			// 	path: "/responses",
			// 	name: "Responses",
			// 	layout: "/aiassistant",
			// 	menuFlag: true,
			// 	component: <AIAssistantResponses />,
			// },
			
			{
				
				name: "Training",
				layout: "/aiassistant",
				menuFlag: true,
				fontIcon: "fa-brain",
				subMenu: [
					{
						name: "PDP",
						path: "/training",
						layout: "/aiassistant",
						component: <AIAssistantTrainingList />,
						menuFlag: true
					},
					{
						path: "/shoppingTraining",
						name: "Shopping",
						layout: "/aiassistant",
						menuFlag: true,
						component: <AIAssistantWebsiteMetadata />,
					},
				],
			},
			{
				path: "/training/add",
				name: "Add PDP Training",
				layout: "/aiassistant",
				menuFlag: false,
				component: <AIAssistantTraining />,
			},
			{
				path: "/training/edit/:trainingId",
				name: "Edit PDP Training",
				layout: "/aiassistant",
				menuFlag: false,
				component: <AIAssistantTraining />,
			},
			// {
			// 	path: "/integrations",
			// 	name: "Integrations",
			// 	layout: "/aiassistant",
			// 	menuFlag: true,
			// 	component: <AIAssistantIntegration />,
			// },
			{
				path: "/settings",
				name: "Settings",
				layout: "/aiassistant",
				fontIcon: "fa-cog",
				menuFlag: true,
				component: <AIAssistantSettings />,
			},
	// 	],
	// },
];

export const SearchRoutes = [
	{
		path: "/dashboard",
		name: "Dashboard",
		component: <SearchDashboard />,
		fontIcon: "fa-desktop",
		layout: "/search",
		type: "searchMenu",
	},
	{
		// path: "/searchOptions/autoComplete",
		name: "Search Options",
		// component: <SearchOptions />,
		fontIcon: "fa-search",
		layout: "/search",
		type: "searchMenu",
		subMenu: [
			{
				path: "/searchOptions/autoComplete",
				name: "Auto Complete",
				layout: "/search",
				menuFlag: true,
				component: <AutoComplete />,
			},
			{
				path: "/searchOptions/instantSearch",
				name: "Instant Search",
				layout: "/search",
				menuFlag: true,
				component: <InstantSearch />,
			},
			{
				path: "/searchOptions/categoryPages",
				name: "Category Pages",
				layout: "/search",
				menuFlag: true,
				component: <Category />,
			},
			{
				path: "/searchOptions/displayFields",
				name: "Display field mapping",
				layout: "/search",
				menuFlag: true,
				availablePlatforms: ["drupal"],
				component: <DisplayFieldMapping />,
			},
			{
				path: "/searchOptions/customRanking",
				name: "Custom Ranking",
				layout: "/search",
				menuFlag: true,
				availablePlatforms: ["drupal"],
				component: <CustomRanking />,
			},
			{
				path: "/searchOptions/searchQueryFields",
				name: "Search fields & weights",
				layout: "/search",
				menuFlag: true,
				availablePlatforms: ["drupal"],
				component: <SearchQueryFieldsSettings />,
			},
			{
				path: "/searchOptions/semanticSearch",
				name: "Semantic Search",
				layout: "/search",
				menuFlag: true,
				availablePlatforms: ["drupal"],
				component: <DrupalSemanticSearchSettingsPage />,
			},
		],
	},
	// {
	// 	name: "Drupal Search",
	// 	fontIcon: "fa-search",
	// 	layout: "/search",
	// 	type: "searchMenu",
	// 	availablePlatforms: ["drupal"],
	// 	subMenu: [
	// 		{
	// 			path: "/drupal/autocomplete",
	// 			name: "Autocomplete",
	// 			layout: "/search",
	// 			menuFlag: true,
	// 			component: <AutocompleteSettings />,
	// 		},
	// 		{
	// 			path: "/drupal/search-result",
	// 			name: "Search Result Page",
	// 			layout: "/search",
	// 			menuFlag: true,
	// 			component: <SearchResultSettings />,
	// 		},
	// 		{
	// 			path: "/drupal/design",
	// 			name: "Design",
	// 			layout: "/search",
	// 			menuFlag: true,
	// 			component: <DesignSettings />,
	// 		},
	// 	],
	// },
	{
		// path: "/design",
		name: "Design",
		// component: <DesignAutoComplete />,
		fontIcon: "fa-palette",
		layout: "/search",
		type: "searchMenu",
		availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
		subMenu: [
			{
				path: "/design/autoComplete",
				name: "Auto Complete",
				layout: "/search",
				menuFlag: true,
				component: <AutoCompleteDesign />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			},
			{
				path: "/design/instantSearch",
				name: "Instant Search",
				layout: "/search",
				menuFlag: true,
				component: <InstantSearchDesign />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			},
		],
	},
	{
		name: "Synonyms",
		fontIcon: "fa-solid fa-exchange-alt",
		layout: "/search",
		type: "searchMenu",
		path: "/synonyms",
		component: <SynonymsList />,
		availablePlatforms: ["shopify", "bigcommerce", "woocommerce", "drupal"]
	},
	//   {
	//     name: "Badge",
	//     fontIcon: "fa-solid fa-tags",
	//     layout: "/search",
	//     type: "searchMenu",
	//     subMenu: [
	//       {
	//         path: "/badge/productbadge",
	//         name: "Products Badge",
	//         layout: "/search",
	//         menuFlag: true,
	//         component: <Badge />,
	//       },
	//     ],
	//   },
	{
		name: "Filters",
		fontIcon: "fa-filter",
		layout: "/search",
		type: "searchMenu",
		availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
		subMenu: [
			{
				path: "/filter",
				name: "Filters",
				layout: "/search",
				menuFlag: true,
				component: <FiltersList />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			},
			{
				path: "/filter/:id",
				name: "Filters",
				layout: "/search",
				menuFlag: false,
				component: <EditFilter />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			},
			{
				path: "/filter/add",
				name: "Filters",
				layout: "/search",
				menuFlag: false,
				component: <AddFilter />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			},
			{
				path: "/colorFamily",
				name: "Color Families",
				layout: "/search",
				menuFlag: true,
				component: <ColorFamilies />,
				availablePlatforms: ["shopify", "bigcommerce", "woocommerce"],
			}
		],
	},
	{
		path: "/merchandising",
		name: "Merchandising",
		component: <Merchandising />,
		fontIcon: "fa-store",
		layout: "/search",
		type: "searchMenu",
		// accessPlans: [3], 
		availablePlatforms: ["shopify", "bigcommerce", "magento", "woocommerce", "drupal"],
		subMenu: [
			{
				path: "/merchandising/category",
				name: "Categories",
				layout: "/search",
				menuFlag: true,
				component: <Categories />,
				availablePlatforms: ["shopify", "bigcommerce", "magento", "woocommerce"],
			},
			{
				path: "/merchandising/search",
				name: "Search",
				layout: "/search",
				menuFlag: true,
				component: <Search />,
			},
			{
				path: "/merchandising/rules",
				name: "Rules",
				layout: "/search",
				menuFlag: true,
				component: <Rules />,
				availablePlatforms: ["shopify", "drupal"],
			},
			{
				path: "/merchandising/rules/add",
				name: "Add Rule",
				layout: "/search",
				menuFlag: false,
				component: <RuleEditor />,
				availablePlatforms: ["shopify", "drupal"],
			},
			{
				path: "/merchandising/rules/edit/:id",
				name: "Edit Rule",
				layout: "/search",
				menuFlag: false,
				component: <RuleEditor />,
			},
			{
				path: "/merchandising/landingPage",
				name: "Landing Page",
				layout: "/search",
				menuFlag: true,
				component: <LandingPage />,
				availablePlatforms: ["magento"],
			},
			{
				path: "/merchandising/promoTitles",
				name: "Promo Titles",
				layout: "/search",
				menuFlag: true,
				component: <PromoTiles />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "magento"],
			},
			{
				path: "/merchandising/banners",
				name: "Banners",
				layout: "/search",
				menuFlag: true,
				component: <Banners />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "magento"],
			},
			// {
			// 	path: "/merchandising/category/edit",
			// 	layout: "/search",
			// 	menuFlag: false,
			// 	component: <EditCategoryMerchandising/>,
			// },
			{
				path: "/merchandising/search/edit",
				layout: "/search",
				menuFlag: false,
				component: <EditSearch />,
			},
			{
				path: "/merchandising/category/edit",
				name: "Categories",
				layout: "/search",
				menuFlag: false,
				component: <EditCategory />,
			},
			{
				path: "/merchandising/landingPage/edit",
				name: "Landing Pages",
				layout: "/search",
				menuFlag: false,
				component: <EditLandingPage />,
				availablePlatforms: ["magento"],
			},
			// {
			// 	path: "/merchandising/woocommerce/category/edit",
			// 	name: "WooCommerce Category Edit",
			// 	layout: "/search",
			// 	menuFlag: false,
			// 	component: <WooCommerceEditCategory />,
			// 	availablePlatforms: ["woocommerce"],
			// },
			// {
			// 	path: "/merchandising/woocommerce/search/edit",
			// 	name: "WooCommerce Search Edit",
			// 	layout: "/search",
			// 	menuFlag: false,
			// 	component: <WooCommerceEditSearch />,
			// 	availablePlatforms: ["woocommerce"],
			// },
		],
	},
	{
		name: "Reports",
		fontIcon: "fa-chart-line",
		layout: "/search",
		type: "searchMenu",
		subMenu: [
			{
				path: "/reports/searchTerms",
				name: "Search Terms",
				layout: "/search",
				menuFlag: true,
				component: <SearchTerms />,
				availablePlatforms: ["magento"]
			},
			{
				path: "/reports/noResults",
				name: "No Results",
				layout: "/search",
				menuFlag: true,
				component: <NoResult />,
				availablePlatforms: ["magento"]
			},
			{
				path: "/reports/productsShown",
				name: "Products Shown",
				layout: "/search",
				menuFlag: true,
				component: <ProductsShown />,
				availablePlatforms: ["magento"]
			},
			{
				path: "/reports/productsClicked",
				name: "Products Clicked",
				layout: "/search",
				menuFlag: true,
				component: <ProductsClicked />,
				availablePlatforms: ["magento"]
			},
			{
				path: "/reports/revenueImpact",
				name: "Revenue Impact",
				layout: "/search",
				menuFlag: true,
				component: <RevenueImpact />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/productKeywords",
				name: "Product Keyword Performance",
				layout: "/search",
				menuFlag: true,
				component: <ProductKeywords />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/keywordProducts",
				name: "Keyword Product Performance",
				layout: "/search",
				menuFlag: true,
				component: <KeywordProducts />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/topPerforming",
				name: "Top Performing Products",
				layout: "/search",
				menuFlag: true,
				component: <TopPerformingProducts />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/lowPerforming",
				name: "Low Performing Products",
				layout: "/search",
				menuFlag: true,
				component: <LowPerformingProducts />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/almostBuy",
				name: "Almost Buy Products",
				layout: "/search",
				menuFlag: true,
				component: <AlmostBuyProducts />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			// {
			// 	path: "/reports/searchConversionFunnel",
			// 	name: "Search Conversion Funnel",
			// 	layout: "/search",
			// 	menuFlag: true,
			// 	component: <SearchConversionFunnel />,
			// },
			{
				path: "/reports/zeroResultQueries",
				name: "Zero-Result Queries Report",
				layout: "/search",
				menuFlag: true,
				component: <ZeroResultQueries />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/ai-synonym-preview",
				name: "AI Synonym Preview",
				layout: "/search",
				menuFlag: false,
				component: <AISynonymPreview />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/lowProductPageViewQueries",
				name: "Low-Product Page View Queries",
				layout: "/search",
				menuFlag: true,
				component: <LowProductPageViewQueries />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			{
				path: "/reports/highIntentLowConversionQueries",
				name: "High-Intent Queries With Low Conversion",
				layout: "/search",
				menuFlag: true,
				component: <HighIntentLowConversionQueries />,
				availablePlatforms: ["bigcommerce", "shopify", "woocommerce", "drupal"],
			},
			// {
			// 	path: "/reports/topPerformingCollection",
			// 	name: "Top Performing Collections",
			// 	layout: "/search",
			// 	menuFlag: true,
			// 	component: <HighPerformingCollections />
			// },
			// {
			// 	path: "/reports/lowPerformingCollection",
			// 	name: "Low Performing Collections",
			// 	layout: "/search",
			// 	menuFlag: true,
			// 	component: <LowPerformingCollections />
			// },
			// {
			// 	path: "/reports/poorPerformanceCollection",
			// 	name: "Poor Performing Collections",
			// 	layout: "/search",
			// 	menuFlag: true,
			// 	component: <PoorPerformingCollections />
			// },
			// {
			// 	path: "/reports/collectionProducts",
			// 	name: "Collection Products Performance",
			// 	layout: "/search",
			// 	menuFlag: true,
			// 	component: <CollectionProduct />,
			// },
		],
	},
];

export const CmsAssistantRoutes = [
	{
		path: "/dashboard",
		name: "Dashboard",
		component: <CmsAssistantDashboard />,
		fontIcon: "fa-desktop",
		layout: "/cmsassistant",
		type: "cmsMenu",
	},
	{
		path: "/content",
		name: "Content",
		component: <CmsAssistantContentSearch />,
		fontIcon: "fa-search",
		layout: "/cmsassistant",
		type: "cmsMenu",
	},
	// {
	// 	path: "/content-sync",
	// 	name: "Content Sync",
	// 	component: <CmsAssistantContentSync />,
	// 	fontIcon: "fa-sync",
	// 	layout: "/cmsassistant",
	// 	type: "cmsMenu",
	// },
	{
		path: "/conversations",
		name: "Conversations",
		component: <CmsAssistantConversations />,
		fontIcon: "fa-comments",
		layout: "/cmsassistant",
		type: "cmsMenu",
	},
	{
		path: "/messengerSettings",
		name: "Messenger Settings",
		component: <MessengerSettings />,
		fontIcon: "fa-comments",
		layout: "/cmsassistant",
		type: "cmsMenu",
	},
	{
		path: "/trainingDocuments",
		name: "Training Documents",
		component: <CmsAssistantTrainingDocuments />,
		fontIcon: "fa-file-lines",
		layout: "/cmsassistant",
		type: "cmsMenu",
	},
	{
		name: "Reports",
		fontIcon: "fa-chart-line",
		layout: "/cmsassistant",
		type: "cmsMenu",
		subMenu: [
			{
				path: "/reports/searchTerms",
				name: "Search terms",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="searchTerms"
						title="Search terms"
						description="Keyword search volume on the results page (hybrid success events with session context)."
					/>
				),
			},
			{
				path: "/reports/zeroKeywordResults",
				name: "Zero keyword results",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="zeroKeywordResults"
						title="Zero keyword results"
						description="Hybrid searches with no keyword hits, including how often AI Overview still answered in the same session."
					/>
				),
			},
			{
				path: "/reports/zeroSessionsNoAi",
				name: "Zero sessions (no AI)",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="zeroSessionsNoAi"
						title="Zero sessions without AI"
						description="Queries where users saw neither keyword results nor an AI overview in the session."
					/>
				),
			},
			{
				path: "/reports/aiOverviews",
				name: "AI overviews",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="aiOverviews"
						title="AI overviews"
						description="AI Overview stream completions by query."
					/>
				),
			},
			{
				path: "/reports/resultsClicked",
				name: "Results clicked",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="resultsClicked"
						title="Results clicked"
						description="Clicks on keyword search result links."
					/>
				),
			},
			{
				path: "/reports/aiCitationsClicked",
				name: "AI citation clicks",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="aiCitationsClicked"
						title="AI citation clicks"
						description="Clicks on sources cited in AI Overviews."
					/>
				),
			},
			{
				path: "/reports/topAiCitations",
				name: "Top AI citations",
				layout: "/cmsassistant",
				menuFlag: true,
				component: (
					<EnterpriseSearchReportPage
						reportKey="topAiCitations"
						title="Top AI citation titles"
						description="Most frequent citation titles shown in AI Overviews."
					/>
				),
			},
		],
	},
];

export const AiVisibilityRoutes = [
	{
		path: "/audit-list",
		name: " AI Grader",
		component: <AiVisibilityDashboard />,
		fontIcon: "fa-file-lines",
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
	},
	{
		path: "/report",
		name: " AI Grader",
		component: <AiVisibilityReport />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/monitoring",
		name: "Monitoring",
		fontIcon: "fa-chart-line",
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		component: <AiVisibilityMonitoring />,
		subMenu: [
			{
				path: "/monitoring/overview",
				name: "Overview",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/history",
				name: "History",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/prompts",
				name: "Prompts",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/analysis",
				name: "Analysis",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/competitors",
				name: "Competitors",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/prompt-research",
				name: "Prompt Research",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/ai-traffic",
				name: "AI Traffic",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/alerts",
				name: "Alerts",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
			{
				path: "/monitoring/settings",
				name: "Settings",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoring />,
			},
		],
	},
	{
		path: "/writing-assistance",
		name: "Content Studio",
		fontIcon: "fa-pen",
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		subMenu: [
			{
				path: "/writing-assistance",
				name: "Fix from Audit",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityWritingAssistance />,
			},
			{
				path: "/writing-assistance/monitoring",
				name: "AI Writing Assistant",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityMonitoringWritingAssistance />,
			},
			// {
			// 	name: "Page Optimizer",
			// 	layout: "/aivisibility",
			// 	menuFlag: true,
			// 	comingSoon: true,
			// },
			// {
			// 	name: "Content Strategist",
			// 	layout: "/aivisibility",
			// 	menuFlag: true,
			// 	comingSoon: true,
			// },
			{
				path: "/dual-lens",
				name: "Dual Lens View",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityDualLens />,
			},
			{
				path: "/llms-txt",
				name: "LLM Discovery",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityLlmsTxt />,
			},
			{
				path: "/schema-optimizer",
				name: "Schema Optimizer",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilitySchemaOptimizer />,
			},
			{
				path: "/deployments",
				name: "Deployments",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityWritingDeployments />,
			},
			{
				path: "/writing-assistance/settings",
				name: "Settings",
				layout: "/aivisibility",
				menuFlag: true,
				component: <AiVisibilityContentStudioSettings />,
			},
			// {
			// 	name: "LLM Discovery",
			// 	layout: "/aivisibility",
			// 	menuFlag: true,
			// 	comingSoon: true,
			// },
		],
	},
	{
		path: "/writing-assistance/view",
		name: "Writing Preview",
		component: <AiVisibilityWritingView />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/deployments/view",
		name: "Writing Deploy Review",
		component: <AiVisibilityWritingDeployView />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/dual-lens/view",
		name: "Dual Lens View",
		component: <AiVisibilityDualLensView />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/llms-txt/view",
		name: "llms.txt View",
		component: <AiVisibilityLlmsTxtView />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/schema-optimizer/run",
		name: "Schema Optimizer Run",
		component: <AiVisibilitySchemaOptimizerRun />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	{
		path: "/schema-optimizer/view",
		name: "Schema Optimizer Job",
		component: <AiVisibilitySchemaOptimizerView />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
	// Legacy audit recommendation list (replaced by top-level Writing Recommendations).
	// {
	// 	path: "/recommendations",
	// 	name: " Recommendation",
	// 	component: <AiVisibilityRecommendations />,
	// 	fontIcon: "fa-lightbulb",
	// 	layout: "/aivisibility",
	// 	type: "aiVisibilityMenu",
	// },

	{
		path: "/writing-recommendations",
		name: "Recommendations",
		component: <AiVisibilityWritingRecommendations />,
		fontIcon: "fa-lightbulb",
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
	},
	{
		path: "/recommendations/view",
		name: "Recommendation View",
		component: <AiVisibilityRecommendationViewPage />,
		layout: "/aivisibility",
		type: "aiVisibilityMenu",
		hidden: true,
	},
];
